export default __webpack_public_path__ + "static/medgas_outlet_w.6adc1866dea486bdbd8be342affb4824.png";